export default __webpack_public_path__ + "static/Holland-7e9beabdc8945605abf7652f4e66a9eb.jpg";